// extracted by mini-css-extract-plugin
export var sliderRange = "_ou-2";
export var sliderRoot = "_ou-0";
export var sliderThumb = "_ou-3";
export var sliderTrack = "_ou-1";